import { Card, SxProps, Theme } from "@mui/material";

import { mergeSx } from "merge-sx";

type ProductCardContainerProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

export function ProductCardContainer(props: ProductCardContainerProps) {
  const { children, sx } = props;
  return (
    <Card
      sx={mergeSx(
        {
          maxWidth: 368,
          minWidth: 315,
          overflow: "visible"
        },
        sx
      )}
      role="region"
      aria-label="Product card container"
    >
      {children}
    </Card>
  );
}
